export function cleanTitle(text, flag) {
    var output = text;
    if (flag === 'cm') {
        output = output.replace(/\s/g, '_');
        output = output.replace(/<[A-Za-z0-9]+[^>]*>|<\/[A-Za-z0-9]+[^>]*>/g, '');
    }
    // eslint-disable-next-line no-useless-escape
    output = output.replace(/<sup>|<\/sup>|&reg;|&trade;|\'|\"|<[A-Za-z0-9]+[^>]*>|<\/[A-Za-z0-9]+[^>]*>/g, '');
    return output;
}

export function reviewCountDisplay(reviews, isCapitalized) {
    var reviewTxt = isCapitalized ? ' Review' : ' review';
    return reviews == 1 ? reviewTxt : reviewTxt + 's';
}

export function defaultImageName(data, defaultValue) {
    if (!data) {
        return !defaultValue ? '' : defaultValue;
    }

    if (
        data.IsWesternDefaultImage &&
        data.IsWesternDefaultImage === true &&
        smartPak.cdProfileCookie.isWesternDiscipline
    ) {
        return data.ImageWestern.length ? data.ImageWestern : data.ImagePath;
    }

    return data.ImagePath;
}

export function possessiveName(name) {
    var hasPluralEnding = name.substr(name.length - 1).toLowerCase() === 's',
        hasEndingS = name + "'",
        hasNoEndingS = name + "'s";

    return hasPluralEnding ? hasEndingS : hasNoEndingS;
}
